import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useTranslation } from "react-i18next";

export type Names = {
  nameAR: string;
  nameEN: string;
};

type OptionsAndAddonAccordionProps = {
  addonsNames: Names[];
  optionsNames: Names[];
};

const OptionsAndAddonAccordion: React.FC<OptionsAndAddonAccordionProps> = ({
  addonsNames,
  optionsNames,
}) => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const isArabic = i18n.language === "ar";

  if (!optionsNames.length && !addonsNames.length) return null;

  return (
    <div className="mt-1 w-full rounded-lg">
      <button
        type="button"
        className="flex w-full items-center justify-between p-2 text-sm font-medium text-gray-500 focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? t("optionsAndAddons.hide") : t("optionsAndAddons.show")}
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="space-y-2 p-2">
          {optionsNames.length > 0 && (
            <div>
              <p className="font-bold text-gray-700">{t("optionsAndAddons.options")}</p>
              <ul className="ml-4 list-disc text-gray-600">
                {optionsNames.map((option, index) => (
                  <li key={index}>
                    {isArabic ? option.nameAR : option.nameEN}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {addonsNames.length > 0 && (
            <div>
              <p className="font-bold text-gray-700">{t("optionsAndAddons.addons")}</p>
              <ul className="ml-4 list-disc text-gray-600">
                {addonsNames.map((addon, index) => (
                  <li key={index}>
                    {isArabic ? addon.nameAR : addon.nameEN}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OptionsAndAddonAccordion;
